import { render, staticRenderFns } from "./ExpansionRatingFeed.vue?vue&type=template&id=c8858802&scoped=true&"
import script from "./ExpansionRatingFeed.vue?vue&type=script&lang=js&"
export * from "./ExpansionRatingFeed.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionRatingFeed.vue?vue&type=style&index=0&id=c8858802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8858802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VExpansionPanelContent,VFlex,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VRating,VSheet})
